import { ErrorStateContainer, ErrorStateTitle, ErrorStateSubtitle } from '../../Styled';
import { SavedViews } from '../../assets/savedViews';

export const SavedViewsAccessDeniedPage = () => {
  return (
    <ErrorStateContainer>
      <SavedViews />
      <ErrorStateTitle data-test="error-state-title">
        Oops… it looks like there was an issue
      </ErrorStateTitle>
      <ErrorStateSubtitle data-test="error-state-subtitle">
        <a href="/messagingInsights">Back to Messaging Insights</a>
      </ErrorStateSubtitle>
    </ErrorStateContainer>
  );
};
